import React from 'react';
import PropTypes from 'prop-types';
import OutsideClickHandler from 'react-outside-click-handler';
import { injectIntl } from 'react-intl';
import DataCacheService from '@/shared/services/DataCacheService';
import intlShape from '@/shared/utils/intlShape';
import CompanyMultiSelect from '@/shared/components/input/multiselect/CompanyMultiSelect';
import EditableToggle from './EditableToggle';

const companyNames = companyIds => {
  const companies = DataCacheService.getDataCache().company;
  return companyIds && companyIds.length
    ? companyIds
        .map(x => companies.find(y => y.id === x))
        .map(x => x.name)
        .join(', ')
    : '';
};

const EditableCompanyMultiSelect = ({
  onChange,
  value,
  disabled,
  submitOnChange,
  className,
  ...rest
}) => (
  <EditableToggle
    onSubmit={onChange}
    value={value}
    disabled={disabled}
    displayValue={companyNames(value)}
    className={className}
  >
    {({ inputValue, setInputValue, submit }) => (
      <OutsideClickHandler onOutsideClick={submit}>
        <CompanyMultiSelect
          {...rest}
          selection={inputValue}
          onChange={e => {
            if (submitOnChange && !!e) {
              setInputValue(e).then(submit);
            } else {
              setInputValue(e);
            }
          }}
        />
      </OutsideClickHandler>
    )}
  </EditableToggle>
);

EditableCompanyMultiSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
  submitOnChange: PropTypes.bool,
  intl: intlShape.isRequired,
  className: PropTypes.string,
};

EditableCompanyMultiSelect.defaultProps = {
  value: [],
  disabled: false,
  submitOnChange: false,
  className: '',
};

export default injectIntl(EditableCompanyMultiSelect);
